import {
  //  DiagnosticsApi,
  TrackingMelcoModelsLogListItem,
  DiagnosticsApi,
  useAPIQuery,
} from "melco-shared-logic";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useUserLogFiles = (userId?: string, productCode?: string) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<TrackingMelcoModelsLogListItem>({
    // pageSizeOptions: [10, 20],
    // pageSize: 20,
  });

  const query = useAPIQuery(
    DiagnosticsApi,
    ["userLogFiles", productCode, currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //const api = new DiagnosticsApi(baseApiConfig({ token, impersonationForId: userId ?? "" }));
      console.log({ filters, currentPage, pageSize });
      let response;
      //   if(filters?.Products) {
      // response = await api.logFilesGetList({

      //   productList: productCode ?? ""

      // });
      // response = await api.logFilesGetList({

      //   productList: productCode ?? ""

      // });

      response = await api.diagnosticsLogFilesGetList({
        productList: productCode ?? "",
      });

      //}

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
      apiConfigOptions: {
        impersonationForId: userId ?? "",
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};
